export default ({ children, style = {}, ...props }) =>
  props.if
    ? <div style={{ display: 'inline', ...style }} { ...props }>{ children }</div>
    : null
